define.alias("ember-truth-helpers/helpers/is-empty", "preview-grid/helpers/is-empty");